import { useTranslation } from 'react-i18next';

import { DealDatePickerCell, useUpdateInWorkOrFinishedDealMutation } from '@crm/entities/deal';

import type { TDeal, TInWorkOrFinishedDeal } from '@crm/entities/deal';

interface NextContactCellProps {
    dealId: TDeal['id'];
    nextContactAt: TInWorkOrFinishedDeal['nextContactAt'];
}

export const NextContactCell = ({ dealId, nextContactAt }: NextContactCellProps) => {
    const { t } = useTranslation();
    const { mutate: updateDeal, isPending } = useUpdateInWorkOrFinishedDealMutation();

    return (
        <DealDatePickerCell
            date={nextContactAt}
            isPending={isPending}
            changeDateAriaLabel={t('crm.common.dealsTable.cells.nextContact.changeDateAriaLabel')}
            clearDateAriaLabel={t('crm.common.dealsTable.cells.nextContact.clearDateAriaLabel')}
            onChange={(date) => {
                updateDeal({
                    dealId,
                    payload: { nextContactAt: date ?? null },
                });
            }}
        />
    );
};
